import React, { createContext, useContext, useMemo } from 'react';
import { message } from 'antd';
import {
  API_ERROR_MESSAGE_KEY,
  canShowApiError,
  markApiErrorShown,
} from '../services/http';
import { isPermissionDeniedMessage } from './apiResponse';

const MessageContext = createContext();

export const CommonMessageProvider = ({ children }) => {
    const [messageApi, contextHolder] = message.useMessage();

    const dedupedMessageApi = useMemo(() => ({
        ...messageApi,
        open: (config) => {
            if (config?.type === 'error') {
                if (
                    isPermissionDeniedMessage(config?.content) ||
                    !canShowApiError()
                ) {
                    return;
                }

                markApiErrorShown();
                return messageApi.open({
                    ...config,
                    key: API_ERROR_MESSAGE_KEY,
                });
            }

            return messageApi.open(config);
        },
    }), [messageApi]);

    return (
        <MessageContext.Provider value={dedupedMessageApi}>
            {contextHolder}
            {children}
        </MessageContext.Provider>
    );
};

export const useCommonMessage = () => {
    return useContext(MessageContext);
};
